/**
 * The zoom level at which the markers should transition from actual size to fixed size.
 */
export var DefaultMarkerActualSizeMinZoom = 6;
